<fw-dialog width="small">
  <fw-dialog-header>
      <fw-icon color="red">warning-circle</fw-icon>
      <h3>API Keys are Expiring!</h3>
  </fw-dialog-header>
  <fw-dialog-content [padded]="true">
    <section *ngIf="userKeys.length > 0">
      <h4>User API Keys</h4>
      <p>
        To manage these API keys, visit your <a href="#/profile">profile</a> page.
      </p>
      <div class="key-list">
        <div class="key-row" *ngFor="let key of userKeys">
          <div class="key-name">
            <fw-icon>key</fw-icon>
            <p>{{ key.label }}</p>
          </div>
          <div class="key-expiry">
            <fw-icon>warning-circle</fw-icon>
            <p>{{key.isExpired ? 'Expired' : 'Expires in ' + key.formattedDate}}</p>
          </div>
        </div>
      </div>
    </section>
    <section *ngIf="deviceKeys.length > 0">
      <h4>Device API Keys</h4>
      <p>To manage these API keys, visit the <a href="#/admin/interfaces">interfaces</a> page.</p>
      <div class="key-list">
        <div class="key-row" *ngFor="let key of deviceKeys">
          <div class="key-name">
            <fw-icon>key</fw-icon>
            <p>{{ key.label }}</p>
          </div>
          <div class="key-expiry">
            <fw-icon>warning-circle</fw-icon>
            <p>{{key.isExpired ? 'Expired' : 'Expires in ' + key.formattedDate}}</p>
          </div>
        </div>
      </div>
    </section>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-checkbox title="Do not show again for these keys"  [(ngModel)]="doNotShow"/>
    <fw-button (click)="close()">
      Dismiss
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>

